/** basic.logOutRecord */
export default {
    logOut_platform: "Платформа деактивации",
    logOut_result: "Результат деактивации",
    logOut_resultLog: "Журнал деактивации",
    logOut_time: "Время деактивации",
}

